import { fmt, signedMoney, pnlColor } from "../lib/format";
import { X, ShieldX } from "lucide-react";

export const PositionsPanel = ({ positions, onClose, onCloseAll }) => {
  const has = positions?.length > 0;
  return (
    <div className="flex-1 min-h-0 flex flex-col">
      <div className="flex items-center justify-between px-2 py-1.5 border-b border-zinc-800">
        <span className="text-[10px] uppercase tracking-wider text-zinc-500">
          {has ? `${positions.length} open` : "no open positions"}
        </span>
        <button
          data-testid="flatten-all-button"
          onClick={() => {
            if (window.confirm("Close ALL open positions now at market and cancel their brackets?")) onCloseAll();
          }}
          disabled={!has}
          className={`flex items-center gap-1 px-2 py-1 rounded-sm text-[10px] font-bold uppercase tracking-wide transition-colors duration-150 ${
            has
              ? "bg-red-500/15 text-red-400 border border-red-500/40 hover:bg-red-500/25"
              : "bg-zinc-800/40 text-zinc-600 border border-zinc-800 cursor-not-allowed"
          }`}
          title="Close all positions immediately"
        >
          <ShieldX size={12} /> Flatten All
        </button>
      </div>
      {!has ? (
        <div className="flex-1 flex items-center justify-center text-zinc-600 text-[11px]">No open positions</div>
      ) : (
        <div className="flex-1 min-h-0 overflow-auto thin-scroll">
          <table className="w-full text-[11px]">
            <thead className="text-[9px] uppercase text-zinc-500 sticky top-0 bg-[#09090b]">
              <tr className="border-b border-zinc-800">
                <th className="text-left font-medium px-2 py-1">Sym</th>
                <th className="text-left font-medium px-1 py-1">Side</th>
                <th className="text-right font-medium px-1 py-1">Qty</th>
                <th className="text-right font-medium px-1 py-1">Entry</th>
                <th className="text-right font-medium px-1 py-1">Last</th>
                <th className="text-right font-medium px-1 py-1">SL</th>
                <th className="text-right font-medium px-1 py-1">TP</th>
                <th className="text-right font-medium px-1 py-1">P&L</th>
                <th className="px-1 py-1"></th>
              </tr>
            </thead>
            <tbody className="font-mono">
              {positions.map((p) => (
                <tr key={p.id} data-testid={`position-${p.symbol}`} className="border-b border-zinc-800/60 hover:bg-zinc-800/30">
                  <td className="px-2 py-1 font-bold text-zinc-100">{p.symbol}</td>
                  <td className={`px-1 py-1 font-semibold ${p.direction === "LONG" ? "text-green-500" : "text-red-500"}`}>{p.direction}</td>
                  <td className="px-1 py-1 text-right text-zinc-300">{p.qty}</td>
                  <td className="px-1 py-1 text-right text-zinc-300">{fmt(p.entry_price)}</td>
                  <td className="px-1 py-1 text-right text-zinc-100">{fmt(p.current_price)}</td>
                  <td className="px-1 py-1 text-right text-red-400">{fmt(p.stop_loss)}</td>
                  <td className="px-1 py-1 text-right text-blue-400">{fmt(p.take_profit)}</td>
                  <td className={`px-1 py-1 text-right font-semibold ${pnlColor(p.pnl)}`}>{signedMoney(p.pnl)}</td>
                  <td className="px-1 py-1 text-right">
                    <button
                      data-testid={`close-position-${p.symbol}`}
                      onClick={() => onClose(p)}
                      className="text-zinc-500 hover:text-red-500 transition-colors duration-150"
                      title="Close this position"
                    >
                      <X size={13} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
